import { render, staticRenderFns } from "./BookingAct.vue?vue&type=template&id=6c95a23d&"
import script from "./BookingAct.vue?vue&type=script&lang=js&"
export * from "./BookingAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports